export default __webpack_public_path__ + "static/media/img-google-meet.a979794a.png";